var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"lbDatePicker\" ng-click=\"vm.closeDatePicker()\">\n<div class=\"lbDatePicker_calendar\" ng-click=\"$event.stopPropagation()\">\n<div pickadate ng-model=\"vm.date\" format=\"{{ vm.dateFormat }}\" on-date-select=\"vm.dateSelected(date)\" min-date=\"vm.minDateFormatted\" max-date=\"vm.maxDateFormatted\" range-from=\"vm.rangeFromFormatted\" range-to=\"vm.rangeToFormatted\"></div>\n<div class=\"lbDatePicker_close\">\n<button class=\"lbDatePicker_close_button\" ng-click=\"vm.closeDatePicker()\" id=\"lbDatePickerClose\">Close</button>\n</div>\n</div>\n</div>\n";
var id1="components/lbDatePicker/lbDatePicker.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbDatePicker/lbDatePicker.html
// module id = 1709
// module chunks = 5